<template>
  <div>
    <!-- 마이키핀. step2 -->
    <div class="step">
      <!-- 하단 콘텐츠 -->
      <div class="bottom-wrap pt20">
        <!-- ocr version -->
        <div class="mt20">
          <div class="phone-wrap mt20">
            <p>{{ "1. 휴대폰 본인인증" }}</p>
            <button @click="AuthPhoneNumber" class="next-button">
              {{ mobileNo == "" ? "휴대폰 인증하기" : mobileNo }}
            </button>
          </div>
        </div>
        <!-- // ocr version -->
      </div>
      <!-- //하단 콘텐츠 -->
    </div>
    <!-- //신원인증 시작. step2 -->
  </div>
</template>
<script>
import Api from "@/common/Api";
// import axios from "axios";
export default {
  created() {
    window.scrollTo(0, 0);
    window.sendResult = this.recieveResult;
  },
  data() {
    return {
      niceVO: {},
      res: false,
      mobileNo: "",
    };
  },
  methods: {
    //ocr version
    AuthPhoneNumber() {
      window.open(
        `https://api.dev.flybit.com/v1/auth/cdd-edd/nice/view/W`,
        "chkPopup",
        "width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no",
      );
    },
    recieveResult(result, niceVO) {
      // console.log로 값 확인 안 됨. alert로 확인할 것
      alert("birthData: " + niceVO.birthData);
      alert("ci: " + niceVO.ci);
      alert("di: " + niceVO.di);
      alert("gender: " + niceVO.gender);
      alert("mobileNo: " + niceVO.mobileNo);
      alert("name: " + niceVO.name);
      alert("nationalInfo: " + niceVO.nationalInfo);
      alert("result: " + result);
      this.mobileNo = niceVO.mobileNo;
    },
  },
};
</script>
<style lang="scss" scoped></style>
